import HeaderResume from '../header-resume/index.vue';
import ModalWarningAction from '../modal-warning-action/index.vue';

const components = {
    HeaderResume,
    ModalWarningAction
};

export default components;
